import {lazyInject} from "@athena-portal/core";
import {
    AnnualPolicyInfo,
    ICustomerPortalService,
    PaymentCard,
    PolicyProperty,
    resourcesHelper,
    Types,
    MAIN_ANNUAL_PAYMENT_CARD
} from "@falcon/services";
import * as React from "react";
import {Link} from "react-router-dom";
import {CardReuseCheckbox} from "../CardReuseCheckbox";
import {CreditCardSection} from "../CreditCardSection";

interface IProps {
    policyNumber: string,
    payment: string,
    handleReuseCardChange?: (reuseValue: boolean) => void
}

interface IState {
    reuseCard?: boolean,
    mainCardId?: string,
    mainPaymentCard?: PaymentCard
}

export class AnnualPaymentCardsSection extends React.Component<IProps, IState> {

    @lazyInject(Types.CustomerPortalService)
    private customerPortalService: ICustomerPortalService;

    constructor(props: any) {
        super(props);

        window.sessionStorage.setItem("product", "annualMotor");

        if (this.props.payment !== undefined) {
            window.sessionStorage.setItem("payment", this.props.payment)
        }

        this.state = {}
    }

    public componentDidMount(): void {
        this.customerPortalService.getPolicyPropertyByPropertyKey(this.props.policyNumber!, MAIN_ANNUAL_PAYMENT_CARD).subscribe(
            (property: PolicyProperty) => {
                this.setState({mainCardId: property.value});

                this.customerPortalService.getAnnualPolicyInfo(this.props.policyNumber!).subscribe((annualPolicyInfo: AnnualPolicyInfo) => {
                    if (property && annualPolicyInfo && annualPolicyInfo.paymentCards) {
                        const mainCards: PaymentCard[] = annualPolicyInfo.paymentCards.filter(c => c.id.toString() === property.value);

                        if (mainCards) {
                            this.setState({
                                mainPaymentCard: mainCards[0],
                                reuseCard: mainCards[0].reuseCard
                            })
                        }
                    }
                });
            }
        );
    }

    public render(): JSX.Element {
        return (
            <div className="text-center mt-4 payment-details-section grid-col-1-2">
                <img className="icon product-section-img icon-card-replace" src={`/${resourcesHelper.THEME}/img/payment-card-icon.png`} alt="credit card icon"/>
                <div className="dashboard-panel-title my-3">Card details</div>
                <CreditCardSection mainCard={this.state.mainPaymentCard} />
                {this.state.mainPaymentCard &&
                    <CardReuseCheckbox reuseCard={this.state.reuseCard}
                                       mainPaymentCard={this.state.mainPaymentCard}
                                       policyNumber={this.props.policyNumber}
                                        handleReuseCardChange={this.props.handleReuseCardChange}/>
                }
                <div className="px-3 my-4 grid-col-2">
                    <Link
                        to={{
                            pathname: `/dashboard/account/changeCard/${this.props.policyNumber}`,
                            state: { policyNumber: this.props.policyNumber }
                        }}
                        className="btn btn-white-dashboard m-auto"
                        id="changeCard">
                        Change card
                    </Link>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/pages/dashboard/common/payments/paymentDetails/annual/AnnualPaymentCardsSection.tsx